// Libraries
import { NgModule } from '@angular/core';
import {
  RouterModule,
  Routes
} from '@angular/router';
import { Angular2TokenService } from 'angular2-token';

// Components
import { AppAdminComponent } from './app-admin.component';

/**
 * Routes for admin module.
 */
const ADMIN_ROUTES: Routes = [
  {
    path: '',
    component: AppAdminComponent,
    canActivate: [Angular2TokenService],
    children: [
      {
        path: '',
        loadChildren: () => new Promise(function (resolve) {  (require as any).ensure([], function (require: any) {    resolve(require('./+dashboard/dashboard.module')['DashboardModule']);  });})
      },
      {
        path: 'puestos',
        loadChildren: () => new Promise(function (resolve) {  (require as any).ensure([], function (require: any) {    resolve(require('./+positions/positions.module')['PositionsModule']);  });})
      },
      {
        path: 'extintores',
        loadChildren: () => new Promise(function (resolve) {  (require as any).ensure([], function (require: any) {    resolve(require('./+extinguishers/extinguishers.module')['ExtinguishersModule']);  });})
      },
      {
        path: 'encuestas',
        loadChildren: () => new Promise(function (resolve) {  (require as any).ensure([], function (require: any) {    resolve(require('./+reviews/reviews.module')['ReviewsModule']);  });})
      },
      {
        path: 'usuarios',
        loadChildren: () => new Promise(function (resolve) {  (require as any).ensure([], function (require: any) {    resolve(require('./+users/users.module')['UsersModule']);  });})
      },
      {
        path: 'vencimientos',
        loadChildren: () => new Promise(function (resolve) {  (require as any).ensure([], function (require: any) {    resolve(require('./+expirations/expirations.module')['ExpirationsModule']);  });})
      },
      {
        path: 'reparaciones',
        loadChildren: () => new Promise(function (resolve) {  (require as any).ensure([], function (require: any) {    resolve(require('./+repairs/repairs.module')['RepairsModule']);  });})
      }
    ]
  }
];

/**
 * `AdminRoutingModule` defines the routes of the admin module.
 */
@NgModule({
  imports: [
    RouterModule.forChild(ADMIN_ROUTES)
  ],
  exports: [
    RouterModule
  ]
})
export class AdminRoutingModule { }

/**
 * Routing components.
 */
export const routingComponents = [
  AppAdminComponent
];



// WEBPACK FOOTER //
// ./~/angular2-template-loader!./~/@angularclass/hmr-loader!./~/angular-router-loader/src!./~/tslint-loader!./src/app/admin/admin.routing.ts